<template>
    <div id="AppConditions" class="app-inner">
         <div class="public-btn-div flex align-cen"  >
      <div class="public-add"  @click="addApp">
        新增工况
      </div>
    </div>
         <div class="p-tit-c">
            <div class="businessList-filter">
                     <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
                    <div class="label">工况名称：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入工况名称" v-model="search" clearable> </el-input>
                    </div>
                    </div>
                     <div class="fl-rt flex align-cen">
                    <div class="label">工况ID：</div>
                    <div class="el-select1">
                        <el-input placeholder="工况ID" v-model="search1" clearable> </el-input>
                    </div>
                    </div>
                </div>
                      <div class="businessList-filter-list flex align-cen">
        <div class="fl-le flex align-cen">
          <div class="label">关联仿真应用：</div>
          <el-select
            v-model="value"
            clearable
            placeholder="请选择"
            @change="classSelect"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.appName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
        <div class="businessList-filter-list flex align-cen">
        <div class="label">启动状态：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio"
        >
          不限
        </div>
        <el-radio v-model="radio" label="1" @change="classSelect" >启用中</el-radio>
        <el-radio v-model="radio" label="0" @change="classSelect">禁用</el-radio>
      </div>
        <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
          搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
            </div>
         </div>
            <div class="businessList-container">
        <div class="businessList-container-table">
          <el-table
                ref="multipleTable"
                :data="list"
                border
                tooltip-effect="dark"
                style="width: 100%"
                id='mytable'
                :header-cell-style="{background:'#eeeeee',color:'#666',paddingBottom:'10px'}"
                >
                     <el-table-column prop="id" label="工况ID" align="center">
                 </el-table-column>
                      <el-table-column prop="name" label="工况名称" align="center">
                 </el-table-column>
                    <el-table-column prop="appName" label="绑定仿真应用" align="center">
                 </el-table-column>
                    <el-table-column prop="simulatePaperNum" label="绑定仿真试卷" align="center">
                                   <template slot-scope="scope">
                        <p style="color:red">{{scope.row.simulatePaperNum}}</p>
                      </template>
                 </el-table-column>
                    <el-table-column label="启用状态" align="center" >
            <template slot-scope="scope">
              <div class="buStatus" @click.stop="changeStatus(scope)">
                <el-switch
                  v-model="scope.row.state == 0 ? false : true"
                  disabled
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
              <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="200"
            >
             <template slot-scope="scope">
                <el-button type="text" size="small"  slot="reference" @click.stop="editPro(scope.row)">编辑</el-button>
                 <el-button type="text" size="small"  slot="reference" style="color:red"  @click.stop="omDetail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
          </el-table>
           <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
            </div>
    </div>
</template>
<script>
import {getApplicationList,getAppConditions,editOm} from "@/api/index/index" //应用列表、分页查询工况列表、修改状态
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
   components:{
      paginaTion,
    },
    data() {
        return {
           search:'',
           search1:'',
           options:[],
           classCurrentPage: 1, //初始页
            classPageSize: 10000, //每页的数据
           currentPage:1,
           pageSize:10,
            value:'',
            radio:'',
            list:[],
            totalCount:0
        }
    },
    activated(){
  this.getList()
},
    created() {
        this.getAllApplist()
    },
    methods: {
        getList(){
            let params = {
                appId:this.value,
                id:this.search1,
                name:this.search,
                states:this.radio,
                current:this.currentPage,
                size:this.pageSize
            }
            getAppConditions(params)
            .then(res =>{
              if(res.data.records){
                this.list = res.data.records
                this.totalCount = res.data.total
              }
            })
        },
        // 获取所有仿真应用
        getAllApplist(){
             let params = {
                appName:'',
                id:'',
                classifyId:'2',
                state:'',
                type:'',
                payType:'',
                current: this.classCurrentPage,
                size:this.classPageSize,
                officialType:''
            }
            getApplicationList(params)
            .then(res =>{
               this.options = res.data.records
            })
        },
        // 筛选
        classSelect(){
           this.currentPage = 1
           this.getList()
        },
        // 启用状态
        allradio(){
          this.radio = ''
          this.currentPage = 1
        this.getList()
        },
        //重置
        reset(){
           this.search1=""
          this.search=""
          this.value = ''
          this.radio = ''
          this.currentPage=1
          this.getList()
        },
        // 新增工况
        addApp(){
          this.$router.push("/editOm")
        },
          // 修改企业
        editPro(data){
           this.$router.push({
            name: "editOm",
            query:{
                id:data.id
            }
           })
        },
        // 查看详情
        omDetail(data){
          this.$router.push({
            name: "omDetail",
            query:{
                id:data.id
            }
           })
        },
        // 状态切换
   changeStatus(e){
       if(e.row.state == 1){
          this.$prompt('禁用后会导致绑定的仿真试卷失效，仍要进行吗？', '工况禁用', {
          inputPlaceholder:'处理备注【必填】',
          inputType:'textarea',
          inputPattern:/^[0-9a-zA-Z\u4E00-\u9FA5\uf900-\ufa2d·s]{1,50}$/,
          inputErrorMessage: '请输入1-50字符',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
            this.editOmstate(e,value)
        }).catch(() => {     
        });
       }else{
        this.editOmstate(e,'')
       }
      },
           editOmstate(e,value){
             editOm({
                id:e.row.id,
                name:e.row.name,
                file:e.row.file,
                appId:e.row.appId,
                state:e.row.state == 1 ? '0' : '1',
                remark:value
                    },'put')
                .then(res => {
                  if(res.code ==1){
                     this.$util.Notifi(res.msg, "error", "fa-exclamation-circle");
                  }else{
                    this.$util.Notifi("修改成功", "success", "fa-check");
                    this.getList()
                  }
                })
                .catch(err => {
                })
        },
                         // 子组件触发
      emitFun(val,val1){
       if(val1 == "PageSize") this.pageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getList()
      },
    },
}
</script>
<style lang="scss" scoped>
  .businessList-container {
    .businessList-container-title {
      font-size: 18px;
      color: #409eff;
      background-color: rgba(242, 242, 242, 1);
      padding: 10px 20px;
      .mft {
        cursor: pointer;
      }
    }
    .businessList-container-table {
      margin-top: 20px;
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
      .buStatus{
        width: 50px;
        margin: 0 auto;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
  ::v-deep{
     .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
  }
</style>